module.exports = __webpack_public_path__ + "static/media/on4.b08491d6.png";